/* ============================================================
   EMMERA — HEADER v3
   Transparent → sticky, mega menu, mobile accordion
   ============================================================ */
(function () {
  'use strict';

  const SCROLL_THRESHOLD = 60;
  const header = document.getElementById('emm-header');
  if (!header) return;

  /* ── Transparent → opaque on scroll ── */
  let lastScroll = 0;
  const isHome = document.body.classList.contains('template-index');

  function updateHeader() {
    const scrollY = window.scrollY;
    if (isHome) {
      if (scrollY > SCROLL_THRESHOLD) {
        header.classList.add('emh--scrolled');
      } else {
        header.classList.remove('emh--scrolled');
      }
    }
    lastScroll = scrollY;
  }

  if (isHome) {
    window.addEventListener('scroll', updateHeader, { passive: true });
    updateHeader();
  } else {
    header.classList.add('emh--scrolled');
  }

  /* ── Mega menus desktop ── */
  const menus = document.querySelectorAll('.emh__nav-item');

  menus.forEach((item) => {
    const panel = item.querySelector('.emh__panel');
    if (!panel) return;

    let closeTimer = null;

    const open = () => {
      clearTimeout(closeTimer);
      menus.forEach((m) => {
        const p = m.querySelector('.emh__panel');
        if (p && p !== panel) {
          p.classList.remove('emh__panel--open');
          m.classList.remove('emh__nav-item--active');
        }
      });
      panel.classList.add('emh__panel--open');
      item.classList.add('emh__nav-item--active');
      document.body.classList.add('emh-overlay-active');
    };

    const close = () => {
      closeTimer = setTimeout(() => {
        panel.classList.remove('emh__panel--open');
        item.classList.remove('emh__nav-item--active');
        document.body.classList.remove('emh-overlay-active');
      }, 120);
    };

    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', close);
    panel.addEventListener('mouseenter', () => clearTimeout(closeTimer));
    panel.addEventListener('mouseleave', close);
  });

  /* Click outside to close */
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.emh__nav-item')) {
      document.querySelectorAll('.emh__panel--open').forEach((p) => p.classList.remove('emh__panel--open'));
      document.querySelectorAll('.emh__nav-item--active').forEach((i) => i.classList.remove('emh__nav-item--active'));
      document.body.classList.remove('emh-overlay-active');
    }
  });

  /* ── Mobile menu ── */
  const mobileToggle = document.getElementById('emh-mobile-toggle');
  const mobileMenu   = document.getElementById('emh-mobile-menu');
  const mobileClose  = document.getElementById('emh-mobile-close');

  const openMobile = () => {
    mobileMenu.classList.add('emh-mobile--open');
    document.body.style.overflow = 'hidden';
    mobileToggle.setAttribute('aria-expanded', 'true');
  };
  const closeMobile = () => {
    mobileMenu.classList.remove('emh-mobile--open');
    document.body.style.overflow = '';
    mobileToggle.setAttribute('aria-expanded', 'false');
  };

  mobileToggle?.addEventListener('click', openMobile);
  mobileClose?.addEventListener('click', closeMobile);

  /* Mobile accordion */
  document.querySelectorAll('.emh-mobile__accordion-toggle').forEach((btn) => {
    btn.addEventListener('click', () => {
      const parent = btn.closest('.emh-mobile__accordion-item');
      const isOpen = parent.classList.contains('emh-mobile__accordion-item--open');
      document.querySelectorAll('.emh-mobile__accordion-item').forEach((it) => {
        it.classList.remove('emh-mobile__accordion-item--open');
      });
      if (!isOpen) parent.classList.add('emh-mobile__accordion-item--open');
    });
  });

  /* Sub-accordion (niveau 2) */
  document.querySelectorAll('.emh-mobile__sub-toggle').forEach((btn) => {
    btn.addEventListener('click', () => {
      const parent = btn.closest('.emh-mobile__sub-item');
      parent.classList.toggle('emh-mobile__sub-item--open');
    });
  });

})();
